import module from '@kendu/ui/module'
import fileSaver from 'file-saver'

function KdHttpInterceptor ($injector, $q, $localStorage, $schema, AppHttpCache, $window, $timeout) {
  const self = this

  self.auth = undefined
  self.request = request
  self.requestError = requestError
  self.response = response
  self.responseError = responseError

  function request (config) {
    config.headers = config.headers || {}

    if ($localStorage.token) {
      config.headers.Authorization = `Bearer ${$localStorage.token}`
    }

    if (typeof config.cache === 'string') {
      config.cache = AppHttpCache.get(config.cache)
    }

    if (config.data && config.schema) {
      config.data = $schema(config.data, config.schema, true)
    }

    if (config.data instanceof $window.FormData) {
      config.transformRequest = (v) => v
      delete config.headers['Content-Type']
    }

    if (config.download) {
      // Todo: extraer en su propio interceptor
      config.responseType = 'blob'
    }

    return config
  }

  function requestError (rejection) {
    return $q.reject(rejection)
  }

  function response (response) {
    if (response.data && response.config.schema) {
      response.data = $schema(response.data, response.config.schema)
    }

    if (typeof response.config.clearCache === 'string') {
      AppHttpCache.clear(response.config.clearCache)
    } else if (response.config.clearCache === true) {
      AppHttpCache.destroy()
    }

    if (response.config.download) {
      // Todo: extraer en su propio interceptor
      let contentDisposition = response.headers('Content-Disposition')
      let content = response.data
      let filename = (/filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i
        .exec(contentDisposition) || [])[2]

      response.data = {
        filename: filename,
        content: content,
        save: (f) => {
          fileSaver.saveAs(content, f || filename)
        },
        open: (target) => {
          let url = $window.URL.createObjectURL(this.content)
          let window = $window.open(url, target || '_blank')

          $timeout(() => {
            $window.URL.revokeObjectURL(url)
          }, 5000)

          if (window) {
            window.focus()

            return true
          } else {
            return false
          }
        },
      }
    }

    return response
  }

  function responseError (rejection) {
    return $q((resolve) => {
      if (!rejection.config.download) {
        return resolve(rejection)
      }

      let reader = new $window.FileReader()

      reader.addEventListener('loadend', (event) => {
        rejection.data = (event.srcElement.result && JSON.parse(event.srcElement.result)) || event.srcElement.result

        resolve(rejection)
      })

      reader.readAsText(rejection.data)
    })
      .then((rejection) => {
        if (rejection.status === 401 && self.auth) {
          return $q.when(self.auth(rejection))
            .then(() => $injector.get('$http')(rejection.config))
            .catch(() => $q.reject(rejection))
        } else {
          return $q.reject(rejection)
        }
      })
  }
}

module.service('KdHttpInterceptor', KdHttpInterceptor)



// WEBPACK FOOTER //
// ./src/kendu/ui/services/KdHttpInterceptor.js